module.exports = __webpack_public_path__ + "img/INF.da2a2715.svg";